import Logo from "@/components/base/Logo";

const quickLinks = [
  { name: "Home", href: "/" },
  { name: "All Courses", href: "/courses" },
  { name: "About", href: "/about" },
  { name: "Gallery", href: "/gallery" },
  { name: "FAQs", href: "/faq" },
  { name: "Contact", href: "/contact" },
  { name: "Privacy Policy", href: "/policies/privacy" },
  { name: "Terms & Conditions", href: "/policies/terms" },
  { name: "Admin Login", href: "/admin/login" },
];

export default function Footer() {
  return (
    <footer
      className="bg-black text-white rounded-t-3xl mt-24 border-t border-white/10"
      role="contentinfo"
      id="contact"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <Logo width={56} height={56} />
              <div>
                <p className="font-bold text-white text-lg leading-tight">NIMAS</p>
                <p className="text-gray-400 text-xs leading-tight">Dirang, Arunachal Pradesh</p>
              </div>
            </div>
            <p className="text-gray-300 text-sm mb-6">
              National Institute of Mountaineering and Adventure Sports — India's premier adventure institute under the Ministry of Defence, Government of India.
            </p>
            <nav aria-label="Social media links">
              <div className="flex items-center space-x-4">
                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  aria-label="Follow us on Instagram"
                >
                  <i className="ri-instagram-line text-xl" aria-hidden="true"></i>
                </a>
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  aria-label="Follow us on Facebook"
                >
                  <i className="ri-facebook-line text-xl" aria-hidden="true"></i>
                </a>
                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  aria-label="Subscribe to our YouTube channel"
                >
                  <i className="ri-youtube-line text-xl" aria-hidden="true"></i>
                </a>
                <a
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  aria-label="Follow us on Twitter"
                >
                  <i className="ri-twitter-x-line text-xl" aria-hidden="true"></i>
                </a>
              </div>
            </nav>
          </div>

          <nav aria-label="Quick links">
            <h4 className="text-lg font-semibold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    className="text-gray-300 text-sm hover:text-white transition-colors cursor-pointer"
                    href={link.href}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <address className="not-italic">
            <h4 className="text-lg font-semibold mb-4 text-white">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start text-gray-300 text-sm">
                <i className="ri-map-pin-line mr-2 mt-0.5 flex-shrink-0 text-primary" aria-hidden="true"></i>
                <span>
                  NIMAS, Dirang, West Kameng District,
                  <br />
                  Arunachal Pradesh — 790 101, India
                </span>
              </li>
              <li className="flex items-center text-gray-300 text-sm">
                <i className="ri-phone-line mr-2 text-primary" aria-hidden="true"></i>
                <a href="tel:+919774231855" className="hover:text-white transition-colors">
                  +91-97742 31855
                </a>
              </li>
              <li className="flex items-center text-gray-300 text-sm">
                <i className="ri-phone-line mr-2 text-primary" aria-hidden="true"></i>
                <a href="tel:+918301026265" className="hover:text-white transition-colors">
                  +91-83010 26265
                </a>
              </li>
              <li className="flex items-center text-gray-300 text-sm">
                <i className="ri-mail-line mr-2 text-primary" aria-hidden="true"></i>
                <a
                  href="mailto:info@nimasdirang.com"
                  className="hover:text-white transition-colors"
                >
                  info@nimasdirang.com
                </a>
              </li>
            </ul>
          </address>
        </div>
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between">
          <p className="text-gray-300 text-sm text-center md:text-left">
            &copy; 2026 NIMAS — National Institute of Mountaineering and Adventure Sports, Dirang. All rights reserved.
          </p>
          <p className="text-gray-400 text-xs mt-2 md:mt-0">
            Under the Ministry of Defence, Government of India
          </p>
        </div>
      </div>
    </footer>
  );
}